import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/cn';

const badgeVariants = cva(
    'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                // DEC-020: el badge `default` es un DESTAQUE (no dominante) → usa el color de
                // acento de marca, no primary.
                default:
                    'border-transparent bg-brand-accent text-brand-accent-foreground hover:bg-brand-accent/80',
                secondary:
                    'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
                destructive:
                    'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
                // DEC-021: badges de ESTADO con el patrón suave fondo/10 + texto fuerte + borde.
                success: 'border-success/40 bg-success/10 text-success',
                warning: 'border-warning/40 bg-warning/10 text-warning',
                info: 'border-info/40 bg-info/10 text-info',
                outline: 'text-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
